import Blue from '~/core'
import { addEvents } from "../utils/index.js";
import { retach } from "../plugins/index.js";

new Blue({
  name: 'Flow Header',
  selector: '.flow-header',
  setup(header) {
    let lastWindowWidth = window.innerWidth;

    const root = document.documentElement; // :root
    const rootStyles = getComputedStyle(root);
    const utilityNav = header.querySelector('.flow-header__utility');
    const mainNav = header.querySelector('.flow-header__main');

    const checkForWave = () => {
      const sectionInner = document.querySelector('.section__inner');
      if (!sectionInner) return;

      const hasWave = Array.from(sectionInner.children)
        .slice(0, 2)
        .some(child =>
          child.classList.contains('composition--wave-bottom') ||
          child.querySelector('.composition--wave-bottom')
        );
      console.log(hasWave);
      if (!hasWave) {
        let contentHeight = header.querySelector('.flow-header__content').offsetHeight;
        header.style.setProperty('height', `${contentHeight}px`);
        header.classList.add('is-filled');
      }
    }

    const setHeaderOffset = () => {
      const headerGapPx = parseFloat(rootStyles.getPropertyValue('--flow-header-gap').trim());

      let offset = 0;
      if (utilityNav && utilityNav.offsetHeight > 0) {
        offset += utilityNav.offsetHeight;
        offset += headerGapPx;
      } else {
        root.style.setProperty('--flow-header-utility-height', `0px`);
      }
      header.style.setProperty('top', `-${offset}px`);
    }

    const closeAllActive = () => {
      [...header.querySelectorAll('.is-open')].forEach((el) => {
        el.classList.remove('is-open')
      });
    };

    const toggleFixedClass = (addScrollListener = false) => {
      const atTop = window.scrollY === 0;
      const mainAtTop = mainNav.getBoundingClientRect().top <= 0;

      if (!atTop && mainAtTop) {
        header.classList.add('is-fixed');
      } else if (atTop) {
        header.classList.remove('is-fixed');
      }

      if (addScrollListener) {
        window.addEventListener('scroll', () => toggleFixedClass(false), { passive: true });
      }
    };

    const bindDropdownEvents = () => {
      const dropdowns = [...header.querySelectorAll('.flow-header__dropdown')];
      if (!dropdowns.length) return;

      dropdowns.forEach((dropdown) => {
        const trigger = dropdown.querySelector('.flow-header__dropdown-trigger');
        addEvents(trigger, "click", (e) => {

          if (dropdown.classList.contains('is-open')) {
            closeAllActive();
          } else {
            closeAllActive();
            dropdown.classList.add('is-open');
          }
        });
      })
    }

    //----------------- MOBILE EVENTS -----------------//
    const bindDrawerToggleEvents = (close = false) => {
      const toggles = [...header.querySelectorAll('.drawer-toggle')];
      if (!toggles.length) return;

      toggles.forEach((toggle) => {
        addEvents(toggle, "click", (e) => {
          header.classList[close ? 'remove' : 'toggle']('is-open');
          let bodyEl = document.querySelector('body');
          if (header.classList.contains('is-open')) {
            bodyEl.classList.add('scroll-lock');
          } else {
            bodyEl.classList.remove('scroll-lock');
          }
          closeAllActive();
        });
      })
    };

    const bindDrawerEvents = () => {
      const drawerContent = header.querySelector('.flow-drawer__content');
      const sitesNav = header.querySelector('.flow-header__sites');
      const linksNav = header.querySelector('.flow-header__links');
      const primaryNav = header.querySelector('.flow-header__nav');
      const languagesNav = header.querySelector('.flow-header__languages');
      const ctasNav = header.querySelector('.flow-header__ctas');

      if (sitesNav) {
        retach(sitesNav, {
          destination: drawerContent,
          movedClass: "flow-drawer__sites",
          mediaQuery: 860,
        });
      }

      if (primaryNav) {
        retach(primaryNav, {
          destination: drawerContent,
          movedClass: "flow-drawer__nav",
          mediaQuery: 1199,
        });
      }

      if (linksNav) {
        retach(linksNav, {
          destination: drawerContent,
          movedClass: "flow-drawer__links",
          mediaQuery: 767,
        });
      }
      if (languagesNav) {
        retach(languagesNav, {
          destination: drawerContent,
          movedClass: "flow-drawer__languages",
          mediaQuery: 860,
        });
      }
      if (ctasNav) {
        retach(ctasNav, {
          destination: drawerContent,
          movedClass: "flow-drawer__ctas",
          mediaQuery: 767,
        });
      }
    }

    //----------------- INIT -----------------//
    const initialize = () => {
      checkForWave();

      setHeaderOffset();

      bindDrawerEvents();
      bindDrawerToggleEvents();
      bindDropdownEvents();

      toggleFixedClass(true);

      addEvents(document, "click", (e) => {
        if (!e.target.closest('.is-open')) {
          closeAllActive();
        }
      });

      window.addEventListener("resize", (e) => {
        if (lastWindowWidth !== window.innerWidth) {
          lastWindowWidth = window.innerWidth;
          setHeaderOffset();
          closeAllActive();
        }
      });
    }

    initialize()
  }
})